// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__Hlz0B","label":"Labeled_label__1qRmZ","divider":"Labeled_divider__A2tY6"};